import InApp from 'detect-inapp'
import Vue from 'vue'
import _ from 'lodash'

function browseInAppCheck (isRedirectToEventHomepage) {
  const inapp = new InApp(navigator.userAgent || navigator.vendor || window.opera)
  if (inapp.isInApp || !inapp.isMobile) {
    Vue.swal({
      title: '請使用網頁瀏覽器開啟導覽服務',
      text: '請確認您是使用行動裝置開啟此項服務',
      type: 'alert'
    }).then(function (result) {
      if (result.value || isRedirectToEventHomepage) {
        location.reload()
      } else {
        return false
      }
    })
  } else {
    return true
  }
}

function browserReloadCheck () {
  const guideId = window.localStorage.getItem('CURRENT_GUIDE_ID')
  if (!_.isNil(window.localStorage.getItem('RELOAD'))) {
    window.localStorage.clear()
    window.localStorage.setItem('CURRENT_GUIDE_ID', guideId)
    location.reload()
  }
}

export default {
  browseInAppCheck,
  browserReloadCheck
}
